import { render, staticRenderFns } from "./addresscontent.vue?vue&type=template&id=2aac8f50&"
import script from "./addresscontent.vue?vue&type=script&lang=js&"
export * from "./addresscontent.vue?vue&type=script&lang=js&"
import style0 from "./addresscontent.vue?vue&type=style&index=0&id=2aac8f50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports